import axios from 'axios';
import user from  '../utils/user';

export default {
  async getPaymentMethodConfigs() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-method-configs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getPaymentMethodConfigsByPolicy(policyId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-method-configs/policy/${policyId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createPaymentMethodConfig(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-method-configs`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updatePaymentMethodConfig(paymentMethod) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-method-configs/${paymentMethod.id}`,
        paymentMethod,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deletePaymentMethodConfig(paymentMethodId) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-method-configs/${paymentMethodId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getInstallmentByPolicy(paymentMethodId, policyId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-method-configs/installments?policyId=${policyId}&paymentMethodId=${paymentMethodId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
